<template lang="pug">
  .sanitary-zone
    .no-print.toolbar
      .mobile-title
        span.mobile-title__number.semibold 12
        span Администрирование
      h1.title {{$translate('Недопустимые для размещения объектов зоны')}}
    .map-layer.map.absolute(ref="map" v-once)
    .legend.legend_sanitary-zone(:class="showMapLegend ? 'opened' : 'closed'" )
      e-perfect-scrollbar
        .legend__head(@click="showMapLegend = !showMapLegend")
          .legend__title {{$translate('Недопустимые для размещения объектов зоны')}}
          button.reset-btn.legend__close(v-if="showMapLegend")
          button.reset-btn.legend__open(v-else)
        .legend__body.no-padding
          button.reset-btn.button.sanitary-zone__add(@click="showCoordinatesModal = true") Добавить зону
          .legend__group
            .legend__zones(v-if="zones.length")
              .zone(v-for="item in zones" :key="item.id" :data-leaflet-id="item.leaflet_id")
                .zone__wrapper(v-if="!isEditable(item)")
                  span.zone__name {{item.name}}
                  .zone__buttons
                    button.button.button_usual.button_edit.reset-btn(@click="editZone(item)") Редактировать
                    button.button.button_usual.button_delete.reset-btn(@click="deleteZone(item)") Удалить
                .zone__edit(v-if="isEditable(item)")
                  label.label.zone__edit-name
                    span Наименование
                    input.input(:value="item.name" @change="(e)=>changeZoneName(e)")
                  label.label.zone__type
                    span Тип зоны
                    select.select.zone__select(@change="(e)=>changeZone(e,item)")
                      option(v-for="type in types" :key="type.id" :value="type.id" :selected="item.type_id===type.id") {{type.name}}
                  button.reset-btn.button.zone__update-coords(@click="updateCoords(item)") Обновить координаты
                  .zone__bottom
                    button.button(@click="cancelEdit(item)") Отменить
                    button.button.button_save.button_green(@click="saveEdit(item)") Сохранить
          .legend__group
            .optimal-calculation.text-center.legend__calculate
              button.button.reset-btn.button_wide(@click="addCalculationModal") Рассчитать место для строительства
          e-modal(
            v-if="showCalculationModal"
            @close="showCalculationModal = false"
            @confirm="confirmCalculationForm"
            title="Расчёт места для строительства"
            saveBtnLabel="Рассчитать"
          )
            slot
            .zone__modal
              select.select.zone__modal-select(:class="{'has-error': showObjectError }" @change="changeObject" v-model="selectedObject" )
                option(value="default" disabled) Выбрать муниципальный район*
                option(v-for="object in objects" :value="object.id") {{object.name}}
              .zone__error(v-if="showObjectError") необходимо выбрать муниципальный район
              .zone__object
                .zone__object-name Тип объекта обращения
                e-checkbox-multi(
                  label="Назначение объекта"
                  :options="actions"
                  labelClassName="display-block zone__type-label"
                  :model="fields"
                  optionTextKey="label"
                  name="tkoActions"
                  optionValueKey="tko_action_id"
                  tabView="null"
                )

              label.zone__label.checkbox.custom-checkbox
                input.visually-hidden.checkbox__input.custom-checkbox__input(type="checkbox" v-model="is_mps")
                span.checkbox__custom.custom-checkbox__block
                span.checkbox__text {{$translate('Этот объект является МПС')}}
    coordinates-modal(
      v-if="showCoordinatesModal"
      :editableCoords="editableCoords"
      @closeForm="showCoordinatesModal = false; editableCoords=[]"
      @setCoordinates="setCoordinates"
      @editCoordinates="editCoordinates"
    )
</template>
<script>
import L from 'leaflet'
import { atu, core, tko } from '@/api/api-endpoints'
import measureMixin from '@/app/geo/mixins/measure-mixin'
import { REGION_CONFIG } from '@/config/regions'
import { MARKER_ICON, TILE_LAYER } from '@/config/map'
import BorderDrawer from '@/utils/map/BorderDrawer'
import { COLORS } from '@/utils'
import url from '@/utils/url'
import CoordinatesModal from './components/CoordinatesModal.vue'
import { convertDmsToDecimal } from '@/utils/coordinates'

export default {
  name: 'SanitaryZone',
  components: { CoordinatesModal },
  mixins: [measureMixin],
  data: () => ({
    map: null,
    borderDrawer: null,
    hasEditableZones: true,
    showMapLegend: true,
    showCalculationModal: false,
    zones: [],
    editableItems: [],
    types: [],
    zoneDefaultNumber: 1,
    objects: [],
    selectedObject: 'default',
    showObjectError: false,
    is_mps: false,
    fields: {
      tkoActions: [],
    },
    marker: null,
    zoneName: null,
    showCoordinatesModal: false,
    editableCoords: [],
    editableItem: null,
  }),
  computed: {
    actions() {
      return REGION_CONFIG.objectAssignments
    },
  },
  methods: {
    async initMap() {
      this.map = L.map(this.$refs.map, {
        center: REGION_CONFIG.map.center,
        zoom: REGION_CONFIG.map.zoom,
        minZoom: REGION_CONFIG.map.minZoom,
        maxZoom: 18,
      })

      L.tileLayer(TILE_LAYER).addTo(this.map)

      this.borderDrawer = new BorderDrawer(this.map, this)
      this.borderDrawer.drawAll(REGION_CONFIG.polygon, [])
    },
    async getBorders() {
      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjectUpdateOrCreate(),
          fromCache: false,
          notReactive: false,
        })
      ).data.data
      const mainBorderLayer = L.layerGroup()

      this.objects.map((border) => {
        if (!border.polygon) {
          return false
        }
        const poly = L.polygon(JSON.parse(JSON.parse(border.polygon)), {
          color: COLORS.red,
          fillColor: COLORS.red,
          fillOpacity: 0,
          weight: 2,
        })
        mainBorderLayer.addLayer(poly)
      })

      mainBorderLayer.addTo(this.map)
    },
    async getZones() {
      this.zones = []
      this.fields.tkoActions = []
      if (this.editableLayers) {
        this.editableLayers.clearLayers()
      }
      this.zones = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.sanitaryZone(),
        })
      ).data.data
      this.zones.sort((a, b) => {
        return a.id - b.id
      })
      this.zoneDefaultNumber = this.zones[this.zones.length - 1]?.id + 1
      this.zones.forEach((item) => {
        setTimeout(() => {
          let coords = item.geometry.coordinates[0]
          coords = coords.map((item) => {
            return [item[1], item[0]]
          })
          const polygon = L.polygon(coords, {
            stroke: true,
            color: COLORS.blue,
            weight: 2,
            fillColor: COLORS.blue,
            fillOpacity: 0.2,
            opacity: 0.5,
            clickable: true,
            dashArray: null,
            dashOffset: null,
          })
          item.leaflet_id = this.editableLayers.getLayerId(polygon)
          this.editableLayers.addLayer(polygon)
          if (this.hasEditableZones) {
            this.updateZoneNumber(item)
            const popup = L.popup()
            popup.setContent(this.addContentToPopupZone(polygon, item.id))
            polygon.bindPopup(popup)
            polygon.on('click', () => {
              polygon.setStyle({ color: COLORS.red })
            })
            polygon.showMeasurements(this.getMeasurementOptions())
          }
        }, 200)
      })
    },
    async addZone(layer) {
      if (this.marker) {
        this.map.removeLayer(this.marker)
      }
      let coordinates = [layer.toGeoJSON().geometry.coordinates.flat()]

      await this.$store.dispatch('createModel', {
        url: atu.sanitaryZone(),
        data: {
          name: 'Зона ' + this.zoneDefaultNumber,
          type_id: 1,
          geometry: {
            type: 'Polygon',
            coordinates,
          },
        },
      })
      await this.getZones()
    },
    async getTypes() {
      this.types = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: core.collection('geo_sanitary_zone_type'),
        })
      ).data.geo_sanitary_zone_type
    },
    async saveEdit(layer) {
      let coordinates = null
      const leaflet_id = layer._leaflet_id || layer.leaflet_id
      const editableItem = this.editableLayers.getLayer(leaflet_id)
      coordinates = [
        await new Promise((resolve) => {
          resolve(editableItem.toGeoJSON().geometry.coordinates.flat())
        }),
      ]
      const zone = this.zones.find((item) => item.leaflet_id === leaflet_id)
      if (zone) {
        zone.name = this.zoneName
        await this.$store.dispatch('updateModel', {
          url: atu.sanitaryZoneUpdate(zone.id),
          data: {
            name: zone.name,
            type_id: zone.type_id,
            geometry: {
              type: 'Polygon',
              coordinates,
            },
          },
        })
      }
      this.cancelEdit(editableItem)
      await this.getZones()
    },
    async deleteZone(item) {
      await this.$store.dispatch('deleteModel', {
        url: atu.sanitaryZoneUpdate(item.id),
        data: { id: item.id },
      })
      this.updateZoneNumber(item, 'down')
      await this.getZones()
    },
    async confirmCalculationForm() {
      if (this.selectedObject === 'default') {
        this.showObjectError = true
        return false
      }

      if (this.marker) {
        this.map.removeLayer(this.marker)
      }
      const geo_object_id = this.selectedObject
      const is_mps = Number(this.is_mps)

      const data = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.optimalObjectCoords({
            query: { geo_object_id, is_mps },
          }),
        })
      ).data

      this.showCalculationModal = false
      this.is_mps = false
      this.selectedObject = 'default'
      const tkoActions = this.fields.tkoActions
      data.forEach((item) => {
        const coords = [item.latitude, item.longitude]
        this.marker = L.marker(coords, { icon: MARKER_ICON })
        this.marker.addTo(this.map)
        const popup = L.popup()
        popup.setContent(
          this.addContentToObject({ is_mps, tkoActions, coords })
        )
        this.marker.bindPopup(popup)
      })
    },
    addContentToObject({ is_mps, tkoActions, coords }) {
      const actions = Object.values(this.actions).filter((item) => {
        return this.fields.tkoActions.includes(item.tko_action_id)
      })
      const actionsToString = actions.map((item) => item.label).join(', ')
      return `
      <div class='object-popup'>
        <div class='tooltip__head'>
        <div class='tooltip__title semibold'>Объект обращения с отходами</div>
      </div>
      <div class='tooltip__body'>
          <div class='tooltip__body-item'>
            <span class='info info--grey'>Назначение объекта:</span>
            <span class='info'>${actionsToString}</span>
          </div>
      </div>
      <div class='tooltip__foot'>
         <button class='object-popup-button button' data-is-mps='${is_mps}' data-actions='${JSON.stringify(
        tkoActions
      )}' data-latitude='${coords.latitude}' data-longitude='${
        coords.longitude
      }'>Подробнее</button>
      </div>
      </div>
      `
    },
    addContentToPopupZone(layer, id = null) {
      const leaflet_id = this.editableLayers.getLayerId(layer)
      const zone = this.zones.find((item) => item.leaflet_id === leaflet_id)
      return `<div class='zone-popup'>
                <div class='zone-popup__name'>${zone.name}</div>
                <div class='zone-popup__buttons'>
                  <button class='reset-btn button zone-popup__item button_delete js-remove-layer' data-id='${id}' data-layer-id='${leaflet_id}'>Удалить</button>
                  <button class='reset-btn button zone-popup__item button_edit js-edit-layer' data-id='${id}' data-layer-id='${leaflet_id}'>Редактировать</button>
                </div>
            </div>
        `
    },
    changeZoneName(event) {
      this.zoneName = event.target.value
    },
    addCalculationModal() {
      this.fields.tkoActions = []
      this.showCalculationModal = true
    },
    addActionsToZonePopup() {
      document.addEventListener('click', async (e) => {
        if (e.target.classList.contains('js-remove-layer')) {
          this.editableLayers.removeLayer(Number(e.target.dataset.layerId))
          await this.$store.dispatch('deleteModel', {
            url: atu.sanitaryZoneDelete(e.target.dataset.id),
          })
          await this.getZones()
        }
        if (e.target.classList.contains('js-edit-layer')) {
          const leaflet_id = Number(e.target.dataset.layerId)
          const item = this.zones.find((item) => item.leaflet_id === leaflet_id)
          this.editableItems.push(item)
        }
      })
    },
    updateZoneNumber(item, type = 'up') {
      let count = type === 'up' ? 1 : -1
      const splitName = item.name?.split(' ')
      if (!zoneName) {
        return false
      }
      const zoneName = splitName[0]
      if (zoneName === 'Зона') {
        this.zoneDefaultNumber = Number(splitName[1]) + count
        if (this.zoneDefaultNumber <= 0) {
          this.zoneDefaultNumber = 1
        }
      }
    },
    editZone(item) {
      this.editableItems.push(item)
    },
    isEditable(item) {
      return this.editableItems.map((el) => el.id).includes(item.id)
    },
    cancelEdit(item) {
      const index = this.editableItems.findIndex((el) => el.id === item.id)
      this.editableItems.splice(index, 1)
    },
    changeZone(e, item) {
      item.type_id = e.target.value
    },
    onDelete() {
      const editableLayers = this.editableLayers

      this.map.on(L.Draw.Event.DELETED, (e) => {
        const layers = e.layers
        layers.eachLayer(async (layer) => {
          const leaflet_id = editableLayers.getLayerId(layer)
          const zone = this.zones.find((item) => item.leaflet_id === leaflet_id)
          if (!zone) {
            return false
          }
          await this.$store.dispatch('deleteModel', {
            url: atu.sanitaryZoneDelete(zone.id),
          })
          this.updateZoneNumber(zone, 'down')
          await this.getZones()
        })
      })
    },
    changeObject() {
      this.showObjectError = false
    },
    getCoordintes(points) {
      const coordinates = [[]]
      points.forEach((point) => {
        const latitude = convertDmsToDecimal({
          degrees: point.latitudeDegrees,
          minutes: point.latitudeMinutes,
          seconds: point.latitudeSeconds,
        })
        const longitude = convertDmsToDecimal({
          degrees: point.longitudeDegrees,
          minutes: point.longitudeMinutes,
          seconds: point.longitudeSeconds,
        })
        coordinates[0].push([latitude, longitude])
      })
      return coordinates
    },
    async setCoordinates(points) {
      const coordinates = this.getCoordintes(points)
      await this.$store.dispatch('createModel', {
        url: atu.sanitaryZone(),
        data: {
          name: 'Зона ' + this.zoneDefaultNumber,
          type_id: 1,
          geometry: {
            type: 'Polygon',
            coordinates,
          },
        },
      })
      await this.getZones()
      this.showCoordinatesModal = false
    },
    updateCoords(item) {
      this.editableCoords = item.geometry.coordinates[0]
      this.editableItem = item.id
      this.showCoordinatesModal = true
    },
    async editCoordinates(points) {
      const coordinates = this.getCoordintes(points)
      const zone = this.editableItems.find(
        (item) => item.id === this.editableItem
      )
      if (zone) {
        await this.$store.dispatch('updateModel', {
          url: atu.sanitaryZoneUpdate(zone.id),
          data: {
            name: zone.name,
            type_id: zone.type_id,
            geometry: {
              type: 'Polygon',
              coordinates,
            },
          },
        })
        await this.getZones()
        this.showCoordinatesModal = false
      }
    },
  },
  mounted() {
    this.initMap()
    this.initMeasure()
    this.getBorders()
    this.getZones()
    this.addActionsToZonePopup()
    this.getTypes()
    this.onDelete()
    if (this.$isMobile()) {
      this.showMapLegend = false
    }

    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('object-popup-button')) {
        const is_mps = Number(e.target.dataset.isMps)
        const tkoActions = JSON.parse(e.target.dataset.actions)
        const latitude = e.target.dataset.latitude
        const longitude = e.target.dataset.longitude
        this.$router.push({
          name: 'registry.objects.create',
          params: { is_mps, tkoActions, latitude, longitude },
          query: {
            prevRoute: url.getRoute(this.$route, true),
          },
        })
      }
    })
  },
}
</script>
